/**
 * Helper to move entry in array. Updates the array in place.
 *
 * Entries will be shifted up or down depending on the direction of the move.
 * If currentIndex or newIndex are out of bounds, or are the same, no action is taken.
 */
export function moveEntry<T>(entries: T[], currentIndex: number, newIndex: number): void {
  if (
    currentIndex === newIndex ||
    currentIndex < 0 ||
    currentIndex >= entries.length ||
    newIndex < 0 ||
    newIndex >= entries.length
  )
    return;
  const [moved] = entries.splice(currentIndex, 1);
  if (!moved) return;
  entries.splice(newIndex, 0, moved);
}
